"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/rac/button";
import { useAuth } from "@/hooks/use-auth";
import { useLoginDialog } from "@/hooks/use-login-dialog";
import { User } from "lucide-react";
import { DesktopTrigger } from "./desktop-trigger";
import { SignInDropdown } from "./dropdown";
import { SignInProps } from "./types";
import { getAvatarUrl, getInitials } from "./utils";
export function SignIn(t0) {
  const $ = _c(12);
  const {
    mobile: t1
  } = t0;
  const mobile = t1 === undefined ? false : t1;
  const {
    isAuthenticated,
    user,
    isLoading
  } = useAuth();
  const {
    openDialog
  } = useLoginDialog();
  if (isLoading) {
    let t2;
    if ($[0] !== mobile) {
      t2 = mobile ? <div className="w-full h-12 rounded-lg bg-gray-200 animate-pulse" /> : <div className="btn-clickable flex items-center gap-2 rounded-md h-10 px-3 py-2 bg-transparent border border-gray-200 w-[120px]"><div className="w-6 h-6 rounded-full bg-gray-200 animate-pulse" /><div className="hidden lg:block h-4 bg-gray-200 animate-pulse rounded flex-1" /></div>;
      $[0] = mobile;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (isAuthenticated && user) {
    if (mobile) {
      return null;
    }
    let t2;
    if ($[2] !== user) {
      const trigger = <DesktopTrigger user={user} getInitials={getInitials} getAvatarUrl={getAvatarUrl} />;
      t2 = <SignInDropdown trigger={trigger} />;
      $[2] = user;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (mobile) {
    let t2;
    if ($[4] !== openDialog) {
      t2 = <Button variant="default" className="w-full h-12 rounded-lg font-medium text-base flex items-center justify-center gap-2 transition-all duration-200 active:scale-[0.98]" aria-label="Log in to your account" onPress={() => openDialog()}>Log in</Button>;
      $[4] = openDialog;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t2;
  if ($[6] !== openDialog) {
    t2 = () => openDialog();
    $[6] = openDialog;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center"><User className="h-4 w-4 text-gray-500" /></div>;
    t4 = <span className="hidden lg:block text-sm font-medium text-gray-700 group-hover:text-primary-foreground truncate flex-1">Log in</span>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2) {
    t5 = <Button variant="outline" className="h-10 px-3 py-2 bg-transparent border border-gray-200 hover:border-gray-300 w-[120px] flex items-center gap-2 focus:bg-transparent data-[focus-visible]:bg-transparent group" aria-label="Log in to your account" onPress={t2}>{t3}{t4}</Button>;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}